import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { onMounted, reactive } from 'vue';
import { fetchDataIngestionTodayAlerts } from '@/features/DataIngestionHomeAlerts/data';
import DataIngestionTodayAlerts from '@/features/DataIngestionHomeAlerts/components/DataIngestionTodayAlerts/DataIngestionTodayAlerts.vue';
import DataIngestionAlertsEmpty from '@/features/DataIngestionHomeAlerts/components/DataIngestionAlertsEmpty/DataIngestionAlertsEmpty.vue';
import DataIngestionTodayAlertsSkeleton from '@/features/DataIngestionHomeAlerts/components/DataIngestionTodayAlertsSkeleton/DataIngestionTodayAlertsSkeleton.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataIngestionAlertsContainer',
    setup(__props) {
        const state = reactive({
            loading: false,
            alerts: [],
        });
        async function getAlerts() {
            state.loading = true;
            const { todayAlerts } = await fetchDataIngestionTodayAlerts({ page: 1 });
            state.alerts = todayAlerts;
            state.loading = false;
        }
        onMounted(() => getAlerts());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (state.loading)
                    ? (_openBlock(), _createBlock(DataIngestionTodayAlertsSkeleton, { key: 0 }))
                    : _createCommentVNode("", true),
                (!state.loading && !state.alerts.length)
                    ? (_openBlock(), _createBlock(DataIngestionAlertsEmpty, { key: 1 }))
                    : _createCommentVNode("", true),
                (!state.loading && state.alerts.length)
                    ? (_openBlock(), _createBlock(DataIngestionTodayAlerts, {
                        key: 2,
                        alerts: state.alerts
                    }, null, 8, ["alerts"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
